export const toLowerAndTrim = (value: string): string => value?.toLowerCase()?.trim();
